// extracted by mini-css-extract-plugin
export default {"base":"HeaderCell_base__OCvLo","content":"HeaderCell_content__5H3TV"};